import { CurrencyPipe } from '@angular/common';
import { Directive, HostListener, ElementRef, OnInit, Input, Injector, AfterViewInit, Renderer2, ViewChild, ChangeDetectorRef } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[currencyFormatter]',
  providers: [
    CurrencyPipe
  ]
})
export class CurrencyFormatterDirective implements OnInit, AfterViewInit {

  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'Clear',
    'Copy', 'Control', 'Del', 'Shift', 'ArrowLeft', 'ArrowLeft'];

  @Input() defaultValue: boolean;

  private regex: RegExp;
  ngControl: NgControl;
  lastValue: number;

  private _setValue(value: any): void {
    this.lastValue = value;
  }

  constructor(
    private el: ElementRef,
    private currencyPipe: CurrencyPipe,
    private inj: Injector,
    private renderer: Renderer2) {
    this.ngControl = this.inj.get(NgControl);
    //this.regex = /^\d+\.?(?:\d+)?$/;
    this.regex = /^\d+\.?\,?(?:\d+)?$/;
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    if (this.defaultValue && !this.ngControl.control.value) {
      this.renderer.setProperty(this.el.nativeElement, 'value', this.currencyPipe.transform(0, 'EUR', 'symbol', '1.0-2'));
    } else {
      this.renderer.setProperty(this.el.nativeElement, 'value', this.currencyPipe.transform(this.ngControl.control.value, 'EUR', 'symbol', '1.0-2'));
      
      this.lastValue = this.ngControl.control.value;
    }
  }

  @HostListener('paste', ['$event'])
  blockPaste(event: ClipboardEvent) {
    const clipboardData = event.clipboardData;
    const pastedText = clipboardData.getData('text');

    if (pastedText && !String(pastedText).match(this.regex)) {
      event.preventDefault();
    }
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (this.specialKeys.indexOf(event.key) !== -1 || event.ctrlKey || event.altKey || event.metaKey) {
      return;
    }

    const current: string = this.el.nativeElement.value;

    const next: string = current.substring(0, this.el.nativeElement.selectionStart) +
      event.key + current.substring(this.el.nativeElement.selectionEnd);

    if (next && !String(next).match(this.regex)) {
      event.preventDefault();
      return;
    }
  }

  @HostListener('focus', ['$event.target.value'])
  onFocus(value): void {
    this.renderer.setProperty(this.el.nativeElement, 'value', !isNaN(value) ? value : '');
  }

  @HostListener('focusout', ['$event.target.value'])
  onFocusOut(value): void {

    if (value.indexOf(',') > -1) {
      value = value.replace(/,/g, '.')
    }
    value = value === '' || value === null ? 0 : value;
    this._setValue(value);
    this.renderer.setProperty(this.el.nativeElement, 'value', this.currencyPipe.transform(value, 'EUR', 'symbol', '1.0-2'));
  }
}
